
import { AfterViewChecked, ChangeDetectorRef, Component, HostListener, OnInit, ViewChild } from '@angular/core';

import { AdminOrderReport, AdminOrderReportParams } from '../../../../../../AngularJS/Goals/Gamification/Models/admin-orders-report';
import { AngularAssignToolService } from '../../../../../reusables/assign-tool/angular-assign-tool.service';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { CvConfigurationService } from 'src/app/reusables/services/cv-configuration.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { CvMultiSelectSelectionChangedArgs } from '../../../../../reusables/multi-select/multi-select.models';
import { AliasPageName } from 'src/app/gamification/cv-marketplace-admin/models/gamification-pages.model';
import { LoginApiModel } from '../../../../../reusables/assign-tool/angular-assign-tool/angular-assign-tool.models';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { OmnibarComponent } from '@niceltd/sol/omnibar';
import { orderBy } from 'lodash';
import { PointStoreCategoriesService } from '../../services/point-store-categories.service';
import { PointStoreNavigationBarService } from '../../services/point-store-navigation-bar.service';
import { PointStorePermissionService } from '../../services/point-store-permission.service';
import { PointStoreProductCardBaseService } from '../../services/point-store-product-card-base.service';
import { PointStoreProductEditService } from '../../services/point-store-product-edit.service';
import { PointStoreProductLandingThumbnailComponent } from '../point-store-product-landing-thumbnail/point-store-product-landing-thumbnail.component';
import { PointStoreProductOrderService } from '../../../agent-side/services/point-store-product-order.service';
import { ShoppingCartService } from '../../../agent-side/services/shopping-cart.service';
import { Validators } from '@angular/forms';
import OverlayScrollbars from 'overlayscrollbars';
import { NavigationService } from 'src/app/navigation/navigation.service';

import moment from 'moment';

@Component({
    selector: 'cv-point-store-product-landing-page',
    templateUrl: './point-store-product-landing-page.component.html',
    styleUrls: ['./point-store-product-landing-page.component.scss',]
})
export class PointStoreProductLandingPageComponent implements OnInit, AfterViewChecked {

    @ViewChild(PointStoreProductLandingThumbnailComponent) thumbnailPageData;
    @ViewChild('filters') filters: OmnibarComponent;

    pspes: any = null;
    pscs: any = null;
    pspos: any = null;
    filterMatchCategory: string = '';
    filterGroupControl = {};
    view = 0; //0 - Thumbnail, 1 - List
    showOrders: boolean = false;
    showOrdersFirstLoad: boolean = false;
    showFilters: boolean = false;
    selectedCategory = null;
    selectedSubCategories = [];
    navFactory: any = null;
    active = 1;

    isCxOne: boolean = false;
    selectedSubCategory = null;
    countProducts: number = 0;
    loading: boolean = false;
    isLoadingProdAndCat: boolean = false;

    //modal
    search: string = '';
    isLoadingLogins: boolean = true;
    loginUsers: LoginApiModel[] = [];
    selectedLoginUsers: any[] = [];
    modalOrderNotification: NgbModalRef;

    status: number[] = [];
    allLabel: string = "";

    searchPlaceholder: string = "";
    countProductsText: string = "";
    sortOptions = [];
    searchBarMaxLength: number = 50;

    scrollOptions: OverlayScrollbars.PartialOptions = {
        scrollbars: {
            autoHide: "leave",
            autoHideDelay: 100,
            theme: "os-theme-dark"
        },
    };
    showTooltip: boolean = false;
    selectAllOnEmpty: boolean = false;
    showText: string = "";

    noPMLicense: boolean = null;

    public localizationDic: Map<string, string> = new Map();

    constructor(
        private pointStoreProductEditService: PointStoreProductEditService,
        private pointStoreCategoriesService: PointStoreCategoriesService,
        private pointStoreProductOrderService: PointStoreProductOrderService, /***change service location* */
        private pointStoreNavigationBarService: PointStoreNavigationBarService,
        private shoppingCartService: ShoppingCartService,
        private pointStorePermissionService: PointStorePermissionService,
        private cvConfigurationService: CvConfigurationService,
        private changeDetectorRef: ChangeDetectorRef,
        private modalService: NgbModal,
        private angularAssignToolService: AngularAssignToolService,
        public config: CvConfigurationService,
        private cvLocalizationService: CVLocalizationService,
        private baseCardService: PointStoreProductCardBaseService,
        private navSrvc: NavigationService,
    ) {
        this.loadLocalizations();
    }

    ngAfterViewChecked() {
        this.changeDetectorRef.detectChanges();
    }

    ngAfterViewInit(){
        const SelectedStatuses = this.pspos.pointStoreProductAdminOrderFilter.SelectedStatuses;
        if (this.status.length === 0 && SelectedStatuses?.length === 0 || !SelectedStatuses) {
            this.status = this.pspos.OrderStatus.map(objeto => objeto.value);
        }
        this.showText = this.getLocalizationStringBySection('Common', 'All', 'All');
        this.pspos.pointStoreProductAdminOrderFilter.SelectedStatuses = this.status;
    }

    async ngOnInit() {
        this.isCxOne = this.cvConfigurationService.isCxOne;
        this.pspes = this.pointStoreProductEditService.pointStoreProductEditObj;
        this.pscs = this.pointStoreCategoriesService.data;
        this.pspos = this.pointStoreProductOrderService.pointStoreProductOrderObj;
        /*this.navFactory = this.navigationService.dataObj;*****/
        //this.adminGroupAssignmentsService.LoadEmpGroups();
        this.pointStoreProductEditService.initializePointStoreAdmin();

        this.loadDataProductsAndCategories();

        this.shoppingCartService.getAttributesInfo();
        //companySettingsFactory.LoadCompanyValues(); ************
        // pointStoreProductOrderService.createOrdersAdminFilter(); **************/
        this.pointStoreCategoriesService.data.isCategoriesChange = false;
        this.maxLengthValidator();

        this.noPMLicense = !this.navSrvc.hasPartnerPMAccess;

    }
    
    @HostListener('window:resize', ['$event'])
    onResize(e: any) {
        let labelContainer: any = document.getElementsByClassName("marketplaceManagementHeader")[0];
        let width = labelContainer?.offsetWidth;
        this.showTooltip = false; 
        if (width < 228) {
            this.showTooltip = true;            
        }
    }

    showTooltipFunction() {
        return this.showTooltip ? this.cvLocalizationService.getCachedText('MarketPlace_Management', 'MarketPlace_Management', '') : '';
    }

    async loadDataProductsAndCategories() {
        this.isLoadingProdAndCat = true;
        await this.pointStoreCategoriesService.loadCategories(true);
        await this.pointStoreCategoriesService.loadCategory();
        await this.loadPermissionList();
        this.loadPlaceholders();
        this.loadSortOptions();
        await this.pointStoreProductEditService.LoadPointStoreProducts();
        this.isLoadingProdAndCat = false;
    }

    async loadLocalizations() {
        this.cvLocalizationService.GetSection("MarketPlace_Management");
        this.cvLocalizationService.GetSection("MarketPlace");
        this.localizationDic = await this.cvLocalizationService.GetSection("Order_Management");
    }

    /**
     * new function to handle the omnibar search event
     * @param searchText
     */
    onTitleFilterChange(searchText: string) {
        this.pspes.pointStoreProductFilter.Title = searchText;
        this.filterChanged();
    }

    filterChanged() {
        if (this.thumbnailPageData) {
            this.thumbnailPageData.updateProductsByRow();
            this.pointStoreCategoriesService.saveFilterState({
                category: this.pointStoreProductEditService.pointStoreProductEditObj.pointStoreProductFilter.Category,
                subcategory: this.pointStoreProductEditService.pointStoreProductEditObj.pointStoreProductFilter.SubCategory
            });
            this.reloadSubcategories();
        }
    }

    clearSearch() {
        this.pspos.pointStoreProductAdminOrderFilter.date;
        this.pointStoreProductEditService.pointStoreProductEditObj.pointStoreProductFilter.Title = "";
        this.pspos.pointStoreProductAdminOrderFilter.searchOrder = "";
        if (this.active == 1) {
            this.filterChanged();
        }
    }

    setThumbnailView() {
        this.view = 0;
    }

    setListView() {
        this.view = 1;
    }

    changeView() {
        if (this.pspes.landingListToolbar.toolbarAction[1].value == false && this.pspes.landingListToolbar.toolbarAction[2].value == false && this.pspes.landingListToolbar.toolbarAction[12].value == false) {
            if (this.view == 0)
                this.view = 1;
            else
                this.view = 0;
        }
    }

    toggleOrders(state) {
        if (state) { // if we are showing orders, set the first load flag to true to trigger compile
            this.showOrdersFirstLoad = true;
            if (this.showText != this.getLocalizationStringBySection('Common', 'All', 'All')) {
                let data = this.showText?.split(", ");
                this.status = this.pspos.OrderStatus
                    .filter(object => data.includes(object.name.toString()))
                    .map(object => object.value);
            } else {
                this.status = this.pspos.OrderStatus.map(object => object.value);
            }            
        }

        //Toggle the show orders bool
        this.showOrders = state;
    }

    async addProduct() {
        const hasCreatePermission: boolean = await this.pointStorePermissionService.validatePermission({
            name: this.pointStorePermissionService.getCreatePermissionName(),
            pageName: this.pointStorePermissionService.pageNameFilter(AliasPageName.MarketplaceManagement),
            newCXoneModalVersion: false
        });
        if (!hasCreatePermission) {
            return;
        }

        this.pointStoreProductEditService.pointStoreProductEditObj.copiedProduct = false;
        this.pointStoreProductEditService.getNewPointStoreProduct();
        this.pointStoreNavigationBarService.setSelectedFrame(1);
        this.pointStoreCategoriesService.resetCategoriesList();
    }

    async addProductCxone() {
        const hasCreatePermission: boolean = await this.pointStorePermissionService.validatePermission({
            name: this.pointStorePermissionService.getCreatePermissionName(),
            pageName: this.pointStorePermissionService.pageNameFilter(AliasPageName.MarketplaceManagement),
            newCXoneModalVersion: false
        });
        if (!hasCreatePermission) {
            return;
        }

        this.pointStoreProductEditService.pointStoreProductEditObj.copiedProduct = false;
        this.pointStoreProductEditService.getNewPointStoreProduct();
        this.pointStoreNavigationBarService.setSelectedFrame(6);
        this.pointStoreCategoriesService.resetCategoriesList();
        this.pointStoreNavigationBarService.setWizardIndex(0);
    }

    toggleFilters() {
        if (this.showOrders == true) {
            //this.OpenOrderFilter(); ***********
        } else {
            //Move the plus button and toggle icon down when filters are opened
            $(".pointStoreImage.add-blue-icon").toggleClass("filtersOpened");
            $(".pointStoreViewToggle").toggleClass("filtersOpened");
            $(".pointStoreThumbnailSortArea").toggleClass("filtersOpened");

            //Toggle the show filters bool
            if (this.showFilters)
                this.showFilters = false;
            else {
                this.showFilters = true;

                if (this.selectedCategory == null) {
                    if (!this.config.isCxOne) {
                        this.selectedCategory = this.pointStoreCategoriesService.data.categoryMap[0];
                        this.selectedSubCategories = this.pointStoreCategoriesService.data.categoryMap[0].m_Item2;
                    } else {
                        this.selectedCategory = this.pscs.categoryList[0];
                        this.categorySelected();
                    }
                    this.pointStoreProductEditService.pointStoreProductEditObj.pointStoreProductFilter.SubCategory = this.allLabel;
                }
            }
        }

        this.pspes.filterOpen = this.showFilters;
    }

    categorySelected() {
        if (this.config.isCxOne) {
            this.selectedSubCategory = null;
            this.pointStoreProductEditService.pointStoreProductEditObj.pointStoreProductFilter.Category = this.selectedCategory.name;
            this.selectedSubCategories = this.selectedCategory.subcategories.map((subCategory, index) => ({
                id: index + 1,
                name: subCategory,
            }));
            //display 'All' as a subcategory on every selectChange event
            this.selectedSubCategory = this.selectedSubCategories[0];
        } else {
            this.pointStoreProductEditService.pointStoreProductEditObj.pointStoreProductFilter.Category = this.selectedCategory.m_Item1;
            this.selectedSubCategories = this.selectedCategory.m_Item2;
        }

        this.pointStoreProductEditService.pointStoreProductEditObj.pointStoreProductFilter.SubCategory = this.allLabel;
        this.filterChanged();
    }

    /**
      * 
      * @param products 
      * @returns 
      */
    productTextString(products: any[]): string {
        let productsText: string = '';
        if (products) {
            for (let index = 0; index < products.length; index++) {
                const variationName = products[index]._PointStoreProductOrderedDTO.VariationName;
                productsText += products[index]._PointStoreProductOrderedDTO.ProductQuantity;
                productsText += " ";
                productsText += products[index]._PointStoreProductOrderedDTO.Title;
                productsText += products[index]._PointStoreProductOrderedDTO.VariationName != "" ? " - " + (!variationName ? 'N/A' : variationName) + " (" : " (";
                productsText += products[index]._PointStoreProductOrderedDTO.ProductCost;
                productsText += ` ${this.cvLocalizationService.getCachedText("MarketPlace", "Coins_Each", "Coins")})`;
                if (index + 1 < products.length) {
                    productsText += ", ";
                }
            }
        }
        return productsText;
    }


    async exportOrdersTable() {
        const dataFiltered: AdminOrderReport[] = this.pspos.dataFiltered.map(({ ...orders }) => {
            const status = this.pspos.OrderStatus.find(status => status.value === orders.OrderStatus);
            return {
                OrderNumber: orders.PointStoreOrderID,
                OrderBy: orders.LoginName,
                AgentId: orders.LoginID,
                DateOrdered: moment(orders.DateOrdered).format('MM/DD/YYYY'),
                TotalCoins: orders.OrderTotal,
                Status: status.name,
                StatusDate: moment(orders.DateOrderStatusChanged).format('MM/DD/YYYY'),
                Notes: orders.Note,
                ProductsText: this.productTextString(orders.ProductsCollection),
                RelatedGroupID: orders.RelatedGroupID,
                RelatedGroupLevel: orders.RelatedGroupLevel
            }
        });

        //selected status param
        const adminOrderFilter = this.pspos.pointStoreProductAdminOrderFilter;
        const selections: [] = !adminOrderFilter.SelectedStatuses ? [] : adminOrderFilter.SelectedStatuses;
        const selectedStatuses = [];
        for (let i = 0; i < this.pspos.OrderStatus.length; i++) {
            if (selections.length > 0 && selections.length < 6) {
                selectedStatuses[i] = !!adminOrderFilter.SelectedStatuses.find(x => x === i + 1);
            } else {
                selectedStatuses[i] = true;
            }
        }

        //loadGroupSelector
        const params: AdminOrderReportParams = {
            StatusValues: selectedStatuses,
            DatePosition: adminOrderFilter.datePosition,
            OrderBy: this.pspos.sortAdminBy,
            Reverse: this.pspos.sortAdminReverse,
            FilterCustomInput: adminOrderFilter.searchOrder,
            format: "excel",
            AdminOrderReportList: dataFiltered,
        }

        const data = await this.pointStoreProductOrderService.buildAdminOrdersReport(params);
        if (data) {
            const currentDate: string = moment().format('MM_DD_YYYY-h_mm_ss-A');
            const fileName = this.cvLocalizationService.getCachedText('MarketPlace_Management', 'Marketplace_Order_History_Export', 'Marketplace_Order_History') + "_" + currentDate + ".xlsx";
            this.downloadFile(data, "excel", fileName);
        }
    }

    /**
     * Downloads a file from a byte array string
     *
     * @param {string} data The byte[] string returned from the endpoint
     * @param {string} mime The mime type to mark the file as
     * @param {string} fileName The name of the file to be downloaded
     * @memberof ModuleContainerComponent
     */
    downloadFile(data, mime, fileName) {
        var decodedData = atob(data);
        var buffer = new ArrayBuffer(decodedData.length);
        var view = new Uint8Array(buffer);
        for (var i = 0; i != decodedData.length; ++i) {
            view[i] = decodedData.charCodeAt(i) & 0xFF;
        }

        var fileData = [buffer];
        var blobObject = new Blob(fileData, { type: mime });
        // non-IE
        // create fake link
        var linkElement = document.createElement('a');
        document.body.appendChild(linkElement);
        linkElement.setAttribute('style', 'display: none;');
        var url = URL.createObjectURL(blobObject);
        linkElement.href = url;
        linkElement.download = fileName;

        // start download
        linkElement.click();

        // cleanup
        URL.revokeObjectURL(linkElement.href);
        linkElement.remove();
    };

    async loadPointStoreProductAdminOrders() {
        this.pointStoreProductOrderService.pointStoreProductOrderObj.isloadingExternalFilter = true;
        await this.pointStoreProductOrderService.LoadPointStoreProductAdminOrders();
    }

    async assignNotifications(notificationModal) {
        const modalOptions: NgbModalOptions = {
            animation: true,
            ariaDescribedBy: 'card-body',
            backdrop: 'static',
            size: 'modal-dialog-noborder-when-loading modal-dialog-centered modal-orderfilters',
            modalDialogClass: 'stopScrolling',
            centered: true,
        };
        this.modalOrderNotification = this.modalService.open(notificationModal, modalOptions);

        const loginUsers: LoginApiModel[] = await this.angularAssignToolService.loadPointStoreLogins();
        if (loginUsers) {
            this.isLoadingLogins = false;
            this.loginUsers = loginUsers;

            const loginsNotification = await this.pointStoreProductOrderService.loadPointStoreOrderLoginsNotification();
            if (loginsNotification) {
                this.selectedLoginUsers = loginsNotification;

                this.loginUsers = this.loginUsers.filter(element =>
                    this.selectedLoginUsers.filter(selectedElement => selectedElement.LoginID == element.LoginID).length == 0
                );
                this.sortLoginUsers();
            }
        }
    }

    async saveNotification() {
        //save selected logins
        const data = await this.pointStoreProductOrderService.savePointStoreOrderLoginsNotifications(this.selectedLoginUsers);
        this.clean();
        this.modalOrderNotification.close();
    };

    onAddLoginUsers(idx, obj) {
        //idx parameter comes with a wrong index when the item is added from search bar.
        let index = this.loginUsers.indexOf(obj);
        this.selectedLoginUsers.push(obj);
        this.loginUsers.splice(index, 1);
        this.sortLoginUsers();
    }

    onRemoveLoginUsers(idx, obj) {
        this.selectedLoginUsers.splice(idx, 1);
        this.loginUsers.push(obj);
        this.sortLoginUsers();
    }

    sortLoginUsers() {
        this.loginUsers = orderBy(this.loginUsers, [login => login.LoginName.toLowerCase()], ['asc']);
    }

    clean() {
        this.search = '';
        this.isLoadingLogins = true;
        this.loginUsers = [];
        this.selectedLoginUsers = [];
    }

    onMultiSelectValueChanged(event: CvMultiSelectSelectionChangedArgs) {
        this.pspos.pointStoreProductAdminOrderFilter.SelectedStatuses = event.value;
        this.getText();
        this.selectAllOnEmpty = this.pspos.pointStoreProductAdminOrderFilter.SelectedStatuses?.length === 0 ? true : false;
    }

    onSelectorClose() {
        this.selectAllOnEmpty = this.pspos.pointStoreProductAdminOrderFilter.SelectedStatuses?.length === 0 ? true : false;
        this.getText();
    }

    getText() {
        const selectedStatuses = this.pspos.pointStoreProductAdminOrderFilter.SelectedStatuses;
        if (selectedStatuses?.length > 0) {            
            const selectedOptions = this.pspos.OrderStatus.filter(option => selectedStatuses.includes(option.value));
            const selectedNames = selectedOptions.map(option => option.name);
            const commaSeparatedNames = selectedNames.join(', ');
            this.showText = selectedStatuses?.length === 0 || selectedStatuses?.length === this.pspos.OrderStatus?.length ? this.getLocalizationStringBySection('Common', 'All', 'All') : commaSeparatedNames;
        } else {
            this.selectAllOnEmpty = false;
            this.status = [];
            this.showText = this.getLocalizationString('None_Selected_Placeholder', 'None Selected');
        }
    }

    getLocalizationStringBySection(section: string = "MarketPlace_Management", key: string, defaultValue: string) {
        return this.cvLocalizationService.getCachedText(section, key, defaultValue);
    }

    /*assignNotifications() {
     var modalInstance = this.$uibModal.open({
       animation: true,
       appendTo: angular.element('.contentWrapper'),
       templateUrl: '../Angular/PointStores/Admin/PointStoreModals/PointStoreManagementNotifications.aspx',
       ariaDescribedBy: 'card-body',
       openedClass: 'stopScrolling',
       backdrop: 'static',
       size: 'modal-dialog-noborder-when-loading modal-dialog-centered modal-orderfilters',
       controller: function ($uibModalInstance) {
         let $inner = this;
         $inner.isLoadingLogins = true;
         $inner.loginUsers = [];
         $inner.selectedLoginUsers = [];
   
         AngularAssignToolFactory.loadPointStoreLogins().then(function (result) {
           $inner.isLoadingLogins = false;
           $inner.loginUsers = result;
   
           return pointStoreProductOrderFactory.loadPointStoreOrderLoginsNotification()
         }).then(
           function (result) {
             $inner.selectedLoginUsers = result;
   
             $inner.loginUsers = $inner.loginUsers.filter(function (element) {
               return $inner.selectedLoginUsers.filter(function (selectedElement) { return selectedElement.LoginID == element.LoginID }).length == 0;
             })
           });
   
         $inner.cancel(){
           $uibModalInstance.dismiss();
         };
   
         $inner.save(){
           //save selected logins
           pointStoreProductOrderFactory.savePointStoreOrderLoginsNotifications($inner.selectedLoginUsers);
   
           $uibModalInstance.close();
         };
   
         $inner.onAdd(idx, obj) {
           //$inner.assignList.push(selectedLoginUsers[row.entity.ID].groupDTO);
           $inner.selectedLoginUsers.push(obj);
           $inner.loginUsers.splice(idx, 1);
         }
         $inner.onRemove(idx, obj) {
           $inner.selectedLoginUsers.splice(idx, 1);
           $inner.loginUsers.push(obj);
           //onremove({ dto: obj });
           //updateAssignTo();
         }
   
       },
       controllerAs: 'ctrlPointStoreProductNotification',
     }).result.finally(function () {
       navFactory.showOverlay = false;
     });
   } */

    /**
     * filter permission list to validate ui control
     * @param permission
     * @returns
     */
    hasPermission(permission: string): boolean {
        return this.pointStorePermissionService.checkPermission(permission,
            this.pointStorePermissionService.pageNameFilter(AliasPageName.MarketplaceManagement)
        );
    }

    async loadPermissionList() {
        await this.pointStorePermissionService.loadPermission(
            this.pointStorePermissionService.pageNameFilter(AliasPageName.MarketplaceManagement)
        );
    }

    loadCountProducts(event) {
        this.countProducts = event;
        this.countProductsText = this.countProducts === 1 ? `${this.countProducts} ${this.cvLocalizationService.getCachedText("MarketPlace_Management", "Product", "Product")}` : `${this.countProducts} ${this.cvLocalizationService.getCachedText("MarketPlace_Management", "Products", "Products")}`;
    }

    loadCountEmptyProducts() {
        this.countProductsText = `${this.countProducts} ${this.cvLocalizationService.getCachedText("MarketPlace_Management", "Products", "Products")}`;
    }
    loadSortOptions() {
        this.sortOptions = [
            { value: 'Title', name: this.cvLocalizationService.getCachedText("MarketPlace", "Title_A_To_Z", "Title: A To Z") },
            { value: '-Title', name: this.cvLocalizationService.getCachedText("MarketPlace", "Title_Z_To_A", "Title: Z To A") },
            { value: 'Price', name: this.cvLocalizationService.getCachedText("MarketPlace", "Price_Low_To_High", "Price: Low To High") },
            { value: '-Price', name: this.cvLocalizationService.getCachedText("MarketPlace", "Price_High_To_Low", "Price: High To Low") },
            { value: 'PointStoreProductID', name: this.cvLocalizationService.getCachedText("MarketPlace_Management", "Created_Newest_To_Oldest", "Created: Newest To Oldest") },
            { value: '-PointStoreProductID', name: this.cvLocalizationService.getCachedText("MarketPlace_Management", "Created_Oldest_To_Newest", "Created: Oldest To Newest") }
        ];
    }

    /**
     * reload the categories on the landing page
     */
    reloadSubcategories() {
        if (this.pscs.isCategoriesChange) {
            if (this.config.isCxOne) {
                this.selectedCategory = this.pscs.categoryList.find(category => category.name === this.selectedCategory?.name);
                this.selectedSubCategories = this.selectedCategory?.subcategories.map((subCategory, index) => ({
                    id: index + 1,
                    name: subCategory,
                }));
            } else {
                this.selectedCategory = this.pscs.categoryMap.find(category => category.m_Item1 === this.selectedCategory?.m_Item1);
                this.selectedSubCategories = this.selectedCategory?.m_Item2;
            }
            this.pointStoreCategoriesService.category$.subscribe((cat: any) => {
                this.pointStoreProductEditService.pointStoreProductEditObj.pointStoreProductFilter.Category = cat.category;
                this.pointStoreProductEditService.pointStoreProductEditObj.pointStoreProductFilter.SubCategory = cat.subcategory;
                this.pspes.pointStoreProductFilter.SubCategory = cat.subcategory;
                if (this.config.isCxOne) {
                    this.selectedSubCategory = this.selectedSubCategories?.find(sub => sub.name === cat.subcategory);
                }
            });
            this.pointStoreCategoriesService.data.isCategoriesChange = false;
        }
    }

    /**
   * clean all filters inside omnibar and the sort by dropdown
   * @returns
   */
    clearFilters() {
        //reset filter
        this.pspes.pointStoreProductFilter = this.pointStoreProductEditService.cleanFilters();
        //reset omnibar searchfield
        this.filters.searchQuery = '';
        //reset dropdowns
        if (this.selectedCategory.name !== this.cvLocalizationService.getCachedText('MarketPlace', 'All', 'All')) {
            this.selectedCategory = this.pscs.categoryList[0];
            this.categorySelected();
            return;
        }
        this.filterChanged();
    }

    /**
     * close the filters calling toggleFiltersSection from omnibar component
     */
    closeFilters() {
        this.filters.toggleFiltersSection();
    }

    /**
     * validate MaxLength in the omnibar search input
     */
    maxLengthValidator() {
        //subscribe to the valuechanges
        this.filters?.searchQueryChange.subscribe((resp: string) => {
            if (resp.length > this.searchBarMaxLength) {
                this.filters.searchQuery = resp.substring(0, this.searchBarMaxLength);
            }
        });
    }

    assignSubCategoryToFilter() {
        this.pointStoreProductEditService.pointStoreProductEditObj.pointStoreProductFilter.SubCategory = this.selectedSubCategory ? this.selectedSubCategory.name : this.allLabel;
        this.filterChanged();
    }

    loadPlaceholders(): void {
        //get the all string based on the localization.
        this.allLabel = this.cvLocalizationService.getCachedText('MarketPlace', 'All', 'All');
        this.searchPlaceholder = this.cvLocalizationService.getCachedText("MarketPlace_Management", "Search_Products_CXOne", "Search...");
        this.loadCountEmptyProducts();
        this.countProductsText = `${this.countProducts} ${this.cvLocalizationService.getCachedText("MarketPlace_Management", "Products", "Products")}`;
    }

    scrollToTop(): void {
        this.thumbnailPageData.scrollToTop();
    }

    getLocalizationString(key: string, defaultValue: string) {
        return this.cvLocalizationService.getCachedText("MarketPlace_Management", key, defaultValue);
    }
}
